var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2542 2.61683L1.60697 19.0199C1.42868 19.3707 1.33435 19.7684 1.33335 20.1736C1.33235 20.5787 1.42473 20.977 1.60128 21.329C1.77784 21.6809 2.03242 21.9742 2.3397 22.1797C2.64698 22.3851 2.99625 22.4955 3.35276 22.5H20.6473C21.0038 22.4955 21.353 22.3851 21.6603 22.1797C21.9676 21.9742 22.2222 21.6809 22.3987 21.329C22.5753 20.977 22.6677 20.5787 22.6667 20.1736C22.6657 19.7684 22.5713 19.3707 22.393 19.0199L13.7458 2.61683C13.5638 2.2759 13.3075 1.99402 13.0017 1.7984C12.6959 1.60277 12.3509 1.5 12 1.5C11.6491 1.5 11.3041 1.60277 10.9983 1.7984C10.6925 1.99402 10.4362 2.2759 10.2542 2.61683V2.61683Z",
    stroke: "#F4A837",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13",
    stroke: "#F4A837",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.0098",
    stroke: "#F4A837",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.fa98c304939dfab18be3284b84cec112.svg";